
export const indexToArr = (col, getKey, group=v=>v) => {
    if (col == null) {
        return null;
    }
    let keys = {};
    for (const e of col) {
        const key = getKey(e);
        if (keys.hasOwnProperty(key)) {
            keys[key].push(e);
        } else {
            keys[key] = [e];
        }
    }

    return Object.keys(keys).map((key) => group(keys[key]));
};